import React from 'react';
import cx from 'classnames';

export const Loading = ({className, size, color, type, ...props}) => (
    <span className={cx("g-loading", size, color, type, className)} {...props}></span>
)